// @flow
import BidHistory from '../../ui/views/bid-history'
import { compose, mapProps, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import {
  formatTime24WithSeconds,
  formatDateCompact
} from '../../core/dateFormater'
import { fetchItemBids } from './actions'
import { getModalItemDetailId, createItemBidsSelector } from './selectors'

const mapStateToProps = (state, props) => {
  const itemId = Number(getModalItemDetailId()(state))
  const bids = itemId && createItemBidsSelector(itemId)(state)
  return { itemId, bids }
}
const withItemBidsData = connect(mapStateToProps, { fetchItemBids })

const withItemBidsOnMount = lifecycle({
  componentWillMount() {
    const { itemId, fetchItemBids } = this.props
    fetchItemBids(itemId)
  }
})

const makeBidsItems = bids =>
  bids &&
  bids.map(bid => ({
    amount: `US $${bid.amount}`,
    time: formatTime24WithSeconds(bid.createdAt),
    date: formatDateCompact(bid.createdAt)
  }))
// { amount: 'US $624', time: '18:32:05', date: 'Jul-02-17' } bid item format

const withPresentationProps = mapProps(({ bids }) => ({
  bidItems: makeBidsItems(bids)
}))

export const BidHistoryEnhancer = compose(
  withItemBidsData,
  withItemBidsOnMount,
  withPresentationProps
)

export default BidHistoryEnhancer(BidHistory)



// WEBPACK FOOTER //
// ./src/services/item/BidHistory.js